import { render, staticRenderFns } from "./video-setting.vue?vue&type=template&id=330d9abf&"
import script from "./video-setting.vue?vue&type=script&lang=js&"
export * from "./video-setting.vue?vue&type=script&lang=js&"
import style0 from "./video-setting.vue?vue&type=style&index=0&id=330d9abf&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports